export const TemplateCycleType = {
	PrivateTemplate: 'PrivateTemplate',
	PublicTemplate: 'PublicTemplate',
} as const;

export type TemplateCycleType = (typeof TemplateCycleType)[keyof typeof TemplateCycleType];

export const FormCycleType = {
	PrivateForm: 'PrivateForm',
	PublicForm: 'PublicForm',
} as const;

export type FormCycleType = (typeof FormCycleType)[keyof typeof FormCycleType];

export const TemplateFormCycleType = {
	...TemplateCycleType,
	...FormCycleType,
} as const;

export type TemplateFormCycleType = (typeof TemplateFormCycleType)[keyof typeof TemplateFormCycleType];

export const EditableCycleStatus = {
	Draft: 'Draft',
	...TemplateCycleType,
	...FormCycleType,
} as const;

export const CompleteCycleStatus = {
	Completing: 'Completing',
	Completed: 'Completed',
} as const;

export const DenyCycleStatus = {
	Denying: 'Denying',
	Denied: 'Denied',
} as const;

export const CancelCycleStatus = {
	Canceling: 'Canceling',
	Canceled: 'Canceled',
} as const;

export const CycleStatusType = {
	...EditableCycleStatus,
	...CompleteCycleStatus,
	...DenyCycleStatus,
	...CancelCycleStatus,
	Cycling: 'Cycling',
	Expired: 'Expired',
	FormFill: 'FormFill',
} as const;
export type CycleStatusType = (typeof CycleStatusType)[keyof typeof CycleStatusType];
